import { Route, Routes } from "react-router";
import Home from "../Pages/Home/Home";
import { allRouteArrays } from "./const";
import "../Pages/Home/home.scss";

const AllRoutes = () => {
  return (
    <>
      <Home>
        <Routes>
          {allRouteArrays.flat().map((route, index) => (
            <Route
              key={`${route.path}-${index}`}
              path={route.path}
              element={route.element}
            />
          ))}
        </Routes>
      </Home>
    </>
  );
};

export default AllRoutes;
